import React, { useState } from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { LiveProvider, LiveEditor, LiveError, LivePreview } from "react-live";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { materialLight } from "react-syntax-highlighter/dist/esm/styles/prism";

interface ShowCodeProps {
  codeString: string;
  scope?: object; // Allows passing components for preview
}

const ShowCode: React.FC<ShowCodeProps> = ({ codeString, scope = {} }) => {
  const [show, setShow] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(codeString);
      alert("Code copied to clipboard!");
    } catch (err) {
      alert("Failed to copy code");
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      {/* Right-aligned toggle button */}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={() => setShow(!show)}>
          {show ? "Hide Code Editor" : "Show Code Editor"}
        </Button>
      </Box>

      {show && (
        <LiveProvider code={codeString} scope={scope}>
          <Box
            sx={{
              mt: 2,
              p: 2,
              border: "1px solid #ccc",
              borderRadius: "8px",
              backgroundColor: "#f5f5f5",
              position: "relative",
            }}
          >
            <IconButton
              onClick={handleCopy}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
              }}
            >
              <ContentCopyIcon/>
            </IconButton>

            {/* Editable code editor */}
            <Box sx={{mb: 2}}>
              <Typography variant={"h5"} sx={{mb: 1}}>Try editing the code here:</Typography>
              <LiveEditor style={{fontFamily: "monospace", fontSize: 14}}/>
            </Box>

            {/* Live preview output */}
            <Typography variant={"h5"} sx={{mb: 1}}>Your component preview:</Typography>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#fff",
                borderRadius: "4px",
                border: "1px solid #ddd",
              }}
            >
              <LivePreview/>
            </Box>

            {/* Live error messages */}
            <Box sx={{color: "red", mt: 1}}>
              <LiveError/>
            </Box>
          </Box>
        </LiveProvider>
      )
      }
    </Box>
  );
};

export default ShowCode;
